import classNames from 'classnames';

import { SelectOption } from '../components/form-item/form-item-types';

export enum Icon {
  JUDGE = 'icon--judge',
  DOCUMENT = 'icon--document',
  ALL = 'icon--all',
  ARROW_UP = 'icon--arrow-up',
  ARROW_DOWN = 'icon--arrow-down',
  ARROW_LEFT = 'icon--arrow-left',
  ARROW_RIGHT = 'icon--arrow-right',
  ANGLE_UP = 'icon--angle-up',
  ANGLE_DOWN = 'icon--angle-down',
  ANGLE_LEFT = 'icon--angle-left',
  ANGLE_RIGHT = 'icon--angle-right',
  ATTACHMENT = 'icon--attachment',
  CALENDAR = 'icon--calendar',
  CHECK = 'icon--check',
  COMPASS = 'icon--compass',
  CROSS = 'icon--cross',
  DOWNLOAD = 'icon--download',
  ELLIPSIS = 'icon--ellipsis',
  EXIT = 'icon--exit',
  EXTERNAL = 'icon--external',
  INFO = 'icon--info',
  LIGHTBULB = 'icon--lightbulb',
  MAIL = 'icon--mail',
  MESSAGE = 'icon--message',
  NOTIFICATIONS = 'icon--notifications',
  PHONE = 'icon--phone',
  PLACE = 'icon--place',
  PLUS = 'icon--plus',
  REMOVE = 'icon--remove',
  SEARCH = 'icon--search',
  SETTINGS = 'icon--settings',
  STAR = 'icon--star',
  TIME = 'icon--time',
  USER = 'icon--user',
  WARNING = 'icon--warning',
  POINT_RIGHT = 'icon--point-right',
  BARS = 'icon--bars',
  FIRE = 'icon--fire',
  LIGHTNING = 'icon--lightning',
  FACEBOOK = 'icon--psk-facebook',
  INSTAGRAM = 'icon--instagram',
  YOUTUBE = 'icon--youtube',
  GOOGLE_PLAY = 'icon--google-play',
  APPLE = 'icon--apple',
  PSK_ARROW_DOWN = 'icon--psk-arrow-down',
  PSK_MENU = 'icon--psk-menu',
  PSK_CROSS = 'icon--psk-cross',
  PSK_TRIANGLE_UP = 'icon--psk-triangle-up',
  PSK_TRIANGLE_DOWN = 'icon--psk-triangle-down',
  PSK_LIST_ARROW_DOWN = 'icon--psk-list-arrow-down',
  PLAY = 'icon--psk-play',
  PAUSE = 'icon--psk-pause',
  PSK_DOWNLOAD = 'icon--psk-download',
}

export enum IconSize {
  '8x8' = 'icon--8x8',
  '16x16' = 'icon--16x16',
  '24x24' = 'icon--24x24',
  '32x32' = 'icon--32x32',
  '48x48' = 'icon--32x32',
  '64x64' = 'icon--64x64',
  '96x96' = 'icon--96x96',
}

export const iconOnly = (
  icon?: Icon | null,
  size: IconSize | null = IconSize['24x24']
) => (icon ? classNames('icon-only', icon, size) : '');

export const iconBefore = (
  icon?: Icon | null,
  size: IconSize | null = IconSize['24x24']
) => (icon ? classNames('icon-before', icon, size) : '');

export const iconAfter = (
  icon?: Icon | null,
  size: IconSize | null = IconSize['24x24']
) => (icon ? classNames('icon-after', icon, size) : '');

export const iconOptions: SelectOption<Icon>[] = [
  {
    value: Icon.JUDGE,
    label: `<div class="${iconOnly(Icon.JUDGE)}"></div>`,
  },
  {
    value: Icon.DOCUMENT,
    label: `<div class="${iconOnly(Icon.DOCUMENT)}"></div>`,
  },
  {
    value: Icon.ALL,
    label: `<div class="${iconOnly(Icon.ALL)}"></div>`,
  },
  {
    value: Icon.ARROW_UP,
    label: `<div class="${iconOnly(Icon.ARROW_UP)}"></div>`,
  },
  {
    value: Icon.ARROW_DOWN,
    label: `<div class="${iconOnly(Icon.ARROW_DOWN)}"></div>`,
  },
  {
    value: Icon.ARROW_LEFT,
    label: `<div class="${iconOnly(Icon.ARROW_LEFT)}"></div>`,
  },
  {
    value: Icon.ARROW_RIGHT,
    label: `<div class="${iconOnly(Icon.ARROW_RIGHT)}"></div>`,
  },
  {
    value: Icon.ANGLE_UP,
    label: `<div class="${iconOnly(Icon.ANGLE_UP)}"></div>`,
  },
  {
    value: Icon.ANGLE_DOWN,
    label: `<div class="${iconOnly(Icon.ANGLE_DOWN)}"></div>`,
  },
  {
    value: Icon.ANGLE_LEFT,
    label: `<div class="${iconOnly(Icon.ANGLE_LEFT)}"></div>`,
  },
  {
    value: Icon.ANGLE_RIGHT,
    label: `<div class="${iconOnly(Icon.ANGLE_RIGHT)}"></div>`,
  },
  {
    value: Icon.ATTACHMENT,
    label: `<div class="${iconOnly(Icon.ATTACHMENT)}"></div>`,
  },
  {
    value: Icon.CALENDAR,
    label: `<div class="${iconOnly(Icon.CALENDAR)}"></div>`,
  },
  {
    value: Icon.CHECK,
    label: `<div class="${iconOnly(Icon.CHECK)}"></div>`,
  },
  {
    value: Icon.COMPASS,
    label: `<div class="${iconOnly(Icon.COMPASS)}"></div>`,
  },
  {
    value: Icon.CROSS,
    label: `<div class="${iconOnly(Icon.CROSS)}"></div>`,
  },
  {
    value: Icon.DOWNLOAD,
    label: `<div class="${iconOnly(Icon.DOWNLOAD)}"></div>`,
  },
  {
    value: Icon.ELLIPSIS,
    label: `<div class="${iconOnly(Icon.ELLIPSIS)}"></div>`,
  },
  {
    value: Icon.EXIT,
    label: `<div class="${iconOnly(Icon.EXIT)}"></div>`,
  },
  {
    value: Icon.EXTERNAL,
    label: `<div class="${iconOnly(Icon.EXTERNAL)}"></div>`,
  },
  {
    value: Icon.INFO,
    label: `<div class="${iconOnly(Icon.INFO)}"></div>`,
  },
  {
    value: Icon.LIGHTBULB,
    label: `<div class="${iconOnly(Icon.LIGHTBULB)}"></div>`,
  },
  {
    value: Icon.MAIL,
    label: `<div class="${iconOnly(Icon.MAIL)}"></div>`,
  },
  {
    value: Icon.MESSAGE,
    label: `<div class="${iconOnly(Icon.MESSAGE)}"></div>`,
  },
  {
    value: Icon.NOTIFICATIONS,
    label: `<div class="${iconOnly(Icon.NOTIFICATIONS)}"></div>`,
  },
  {
    value: Icon.PHONE,
    label: `<div class="${iconOnly(Icon.PHONE)}"></div>`,
  },
  {
    value: Icon.PLACE,
    label: `<div class="${iconOnly(Icon.PLACE)}"></div>`,
  },
  {
    value: Icon.PLUS,
    label: `<div class="${iconOnly(Icon.PLUS)}"></div>`,
  },
  {
    value: Icon.REMOVE,
    label: `<div class="${iconOnly(Icon.REMOVE)}"></div>`,
  },
  {
    value: Icon.SEARCH,
    label: `<div class="${iconOnly(Icon.SEARCH)}"></div>`,
  },
  {
    value: Icon.SETTINGS,
    label: `<div class="${iconOnly(Icon.SETTINGS)}"></div>`,
  },
  {
    value: Icon.STAR,
    label: `<div class="${iconOnly(Icon.STAR)}"></div>`,
  },
  {
    value: Icon.TIME,
    label: `<div class="${iconOnly(Icon.TIME)}"></div>`,
  },
  {
    value: Icon.USER,
    label: `<div class="${iconOnly(Icon.USER)}"></div>`,
  },
  {
    value: Icon.WARNING,
    label: `<div class="${iconOnly(Icon.WARNING)}"></div>`,
  },
  {
    value: Icon.POINT_RIGHT,
    label: `<div class="${iconOnly(Icon.POINT_RIGHT)}"></div>`,
  },
  {
    value: Icon.BARS,
    label: `<div class="${iconOnly(Icon.BARS)}"></div>`,
  },
  {
    value: Icon.FIRE,
    label: `<div class="${iconOnly(Icon.FIRE)}"></div>`,
  },
  {
    value: Icon.LIGHTNING,
    label: `<div class="${iconOnly(Icon.LIGHTNING)}"></div>`,
  },
  {
    value: Icon.FACEBOOK,
    label: `<div class="${iconOnly(Icon.FACEBOOK)}"></div>`,
  },
  {
    value: Icon.INSTAGRAM,
    label: `<div class="${iconOnly(Icon.INSTAGRAM)}"></div>`,
  },
  {
    value: Icon.YOUTUBE,
    label: `<div class="${iconOnly(Icon.YOUTUBE)}"></div>`,
  },
  {
    value: Icon.GOOGLE_PLAY,
    label: `<div class="${iconOnly(Icon.GOOGLE_PLAY)}"></div>`,
  },
  {
    value: Icon.APPLE,
    label: `<div class="${iconOnly(Icon.APPLE)}"></div>`,
  },
  {
    value: Icon.PSK_ARROW_DOWN,
    label: `<div class="${iconOnly(Icon.PSK_ARROW_DOWN)}"></div>`,
  },
  {
    value: Icon.PSK_TRIANGLE_DOWN,
    label: `<div class="${iconOnly(Icon.PSK_TRIANGLE_DOWN)}"></div>`,
  },
  {
    value: Icon.PLAY,
    label: `<div class="${iconOnly(Icon.PLAY)}"></div>`,
  },
  {
    value: Icon.PAUSE,
    label: `<div class="${iconOnly(Icon.PAUSE)}"></div>`,
  },
  {
    value: Icon.PSK_DOWNLOAD,
    label: `<div class="${iconOnly(Icon.PSK_DOWNLOAD)}"></div>`,
  },
];

export const iconSizeOptions: SelectOption<IconSize>[] = [
  {
    value: IconSize['8x8'],
    label: '8x8',
  },
  {
    value: IconSize['16x16'],
    label: '16x16',
  },
  {
    value: IconSize['24x24'],
    label: '24x24',
  },
  {
    value: IconSize['32x32'],
    label: '32x32',
  },
  {
    value: IconSize['48x48'],
    label: '48x48',
  },
  {
    value: IconSize['64x64'],
    label: '64x64',
  },
  {
    value: IconSize['96x96'],
    label: '96x96',
  },
];
